import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import JobList from "./components/JobList";
import TextInput from "../../components/TextInput";
import { getJobList, setSearchQuery, setSuccess, setError, setCurrentPage } from "../../reducers/companyJob";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import Copyright from "../../components/Copyright";
import {trimStringFields} from "utils/format";

const JobManagement = () => {
  const location = useLocation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const {
    loading,
    success,
    error,
    currentPage,
    pageSize,
    jobListData,
    sortBy,
    sortOrder,
    searchQuery,
    filterOption,
    isReloadJobList, actionName, actionStatus, jobRankAOnly, jobSelectedTypeOfTalent
  } = useSelector((state: any) => state.companyJob);

  const fetchJob = (page = currentPage, search=searchQuery) => {
    let data = {
      search: search,
      page: page,
      pageSize: pageSize,
      sortBy: sortBy,
      sortOrder: sortOrder,
      option: filterOption?.id,
      rankAOnly: jobRankAOnly ? 1 : 0,
      talentType: jobSelectedTypeOfTalent && jobSelectedTypeOfTalent?.value ? jobSelectedTypeOfTalent.value : null,
    }
    data = trimStringFields(data);
    dispatch(getJobList(data));
    dispatch(setCurrentPage(page));
  }

  useEffect(() => {
    fetchJob();
  }, [sortBy, sortOrder, currentPage, isReloadJobList]);

  const handleSetSearchQuery = (value: string) => {
    dispatch(setSearchQuery(value));
  };

  const handeSearchJob = (event: any) => {
    if (event.key === "Enter") {
      fetchJob(1);
    }
  };

  const handleClearSearch = () => {
    handleSetSearchQuery("");
    fetchJob(1, "");
  }
  
  const jobList = jobListData.map((item: any) => ({
    ...item,
    type: item.type.label,
    employmentStatus: item.occupation_2.name,
    date: !item.is_public && item.is_public_scheduled && item.public_schedule_date ? item.public_schedule_date : item.public_date,
    views: item.number_of_views,
    saveCount: item.number_of_saves,
    applications: item.number_of_responses,
  }));

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if ((actionStatus == 'fulfilled' || actionStatus == 'rejected') 
        && (actionName == 'updateJobStatus') 
        && (error || success)) {
      enqueueSnackbar("I love snacks.", {
        content: (key) => (
          <CustomToast
            title={"メッセージ"}
            message={error ? error : success}
            variant={error ? "error" : "success"}
            snackbarKey={key}
            closeSnackbar={closeSnackbar}
          />
        ),
      });
      dispatch(setError(null));
      dispatch(setSuccess(null));
    } else {
      if(actionName == 'deleteJobByIds') {
        if(actionStatus == 'fulfilled' || actionStatus == 'rejected') {
          enqueueSnackbar("I love snacks.", {
            content: (key) => (
              <CustomToast
                title={"メッセージ"}
                message={error ? error: success}
                variant={error ? "error" : "success"}
                snackbarKey={key}
                closeSnackbar={closeSnackbar}
              />
            ),
          });
          dispatch(setError(null));
          dispatch(setSuccess(null));
        }
      }
    }
  }, [actionStatus, actionName, error, success]);

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-bold leading-[1.875rem] alu-text-base-2">
              求人一覧
            </h1>
            <TextInput
              id="search"
              name="search"
              value={searchQuery}
              onChange={(e: any) => handleSetSearchQuery(e.target.value)}
              onKeyDown={(e: any) => handeSearchJob(e)}
              placeholder="検索"
              searchIcon={true}
              onClearQuery={() => handleClearSearch()}
            />
          </div>
          <div className="mt-6">
            <JobList jobList={jobList} />
          </div>
        </div>
      </div>
      <Copyright view="company" />
    </>
  );
};

export default JobManagement;
